import React from "react";

export default function FooterAdmin() {
  return (
    <>
      <footer className="block py-4">
        <div className="container px-4">
          <div className="flex flex-wrap items-end justify-end">
            <div className="w-full md:w-full px-4">
              <div className="text-sm text-blueGray-500 font-semibold py-1 text-center md:text-left">
                Copyright © {new Date().getFullYear()}{" "} AI Platform
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
